import { render, staticRenderFns } from "./MatchingPhonics1Form.vue?vue&type=template&id=43a1c236&"
import script from "./MatchingPhonics1Form.vue?vue&type=script&lang=js&"
export * from "./MatchingPhonics1Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports